/**
 * Stamp owner-set association weekly rates onto machine relatedAttachments.
 *
 * The machines search index only stores monthly `cost`. Without this, weekly
 * rental pills fall back to monthly ÷ 3 even when admin set a different weekly.
 */
export type AssociationWeeklySource = {
  childItemId?: string;
  weeklyPrice?: number;
};

export type AttachmentWeeklyTarget = {
  inventoryItemId?: string;
  childItemId?: string;
  weeklyPrice?: number;
};

export function asAssociationList(associations: unknown): AssociationWeeklySource[] {
  if (Array.isArray(associations)) {
    return associations;
  }
  if (associations && typeof associations === "object") {
    const wrapped = associations as { results?: unknown; value?: unknown };
    if (Array.isArray(wrapped.results)) {
      return wrapped.results;
    }
    if (Array.isArray(wrapped.value)) {
      return wrapped.value;
    }
  }
  return [];
}

export function applyAssociationWeeklyPrices(
  attachments: AttachmentWeeklyTarget[] | null | undefined,
  associations: unknown,
): void {
  if (!attachments?.length) {
    return;
  }

  const weeklyByChildId = new Map<string, number>();
  for (const association of asAssociationList(associations)) {
    const id = association?.childItemId;
    const weekly = Number(association?.weeklyPrice);
    // Keep an explicit $0 weekly (free for the week). Skip only missing/invalid values
    // so pills can still derive monthly ÷ 3 when the owner never set a weekly rate.
    if (id && association?.weeklyPrice != null && Number.isFinite(weekly) && weekly >= 0) {
      weeklyByChildId.set(id, weekly);
    }
  }

  for (const attachment of attachments) {
    const id = attachment.inventoryItemId || attachment.childItemId;
    const weekly = id ? weeklyByChildId.get(id) : undefined;
    if (weekly != null) {
      attachment.weeklyPrice = weekly;
    }
  }
}
